import { render, staticRenderFns } from "./PreviousNextButtons.vue?vue&type=template&id=56107714&scoped=true"
import script from "./PreviousNextButtons.vue?vue&type=script&lang=js"
export * from "./PreviousNextButtons.vue?vue&type=script&lang=js"
import style0 from "./PreviousNextButtons.vue?vue&type=style&index=0&id=56107714&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56107714",
  null
  
)

export default component.exports